import { connection } from "@/lib/connection";
import { apiUrl } from "@/lib/config";
import { CheckoutPayload } from "@/schemas/checkout.schema";
import { CompraStatus } from "@/store/evento/compra.slice";

export type CheckoutSyncResponse = {
    success: boolean;
    msg: string;
    data?: {
        compraId: number;
        status: string;
        paymentId?: string;
        accessToken?: string;
        tickets?: CompraStatus["tickets"];
    };
    // fallback para legacy si no viene envuelto
    compraId?: number;
    status?: string;
    paymentId?: string;
    accessToken?: string;
    tickets?: CompraStatus["tickets"];
    mode?: never;
};

export type CheckoutRedirectResponse = {
    success: boolean;
    mode: 'redirect';
    checkoutUrl: string;
    paymentId: string;
    compraId: number;
    accessToken: string;
    gateway: 'allaria';
    data?: any;
};

export type CheckoutResponse = CheckoutSyncResponse | CheckoutRedirectResponse;

type CheckoutPayloadWithReserva = CheckoutPayload & {
    reservaId: string;
    paymentData?: Record<string, any>;
};

export async function checkout(payload: CheckoutPayloadWithReserva): Promise<CheckoutResponse> {
    const data = await connection<any>(apiUrl(`/checkout`), 'POST', {}, { ...payload, origin: 'online', medioPago: 'credito' });
    return data;
}

export async function getAllariaOrderStatus(paymentId: string, accessToken: string) {
    const data = await connection<any>(
        apiUrl(`/checkout/allaria/status/${paymentId}`),
        'GET',
        { 'X-Compra-Access-Token': accessToken }
    );
    return data;
}
